require("fslightbox");

const init = () => {

    /*
    const el = document.querySelector('#lightbox');

    if(!el){ return; }

    var lightbox = new FsLightbox();
    */
};

export default {init};
